import React from 'react';
import './RepairSection.css';
import PhoneLink from './PhoneLink';

function RepairSection() {
  return (
    <section className="repair-section">
      <div className="container">
        <h1>Profesjonalna naprawa dachów w Szczecinie</h1>
        
        <div className="intro-text">
          <p>
            <strong>Bezpieczny Dach</strong> oferuje kompleksowe naprawy dachów w Szczecinie i okolicach. 
            Działamy na rynku od 15 lat, zapewniając najwyższą jakość usług dekarskich dla wspólnot mieszkaniowych, zarządców nieruchomości, generalnych wykonawców i instytucji publicznych.
          </p>
        </div>
        
        <div className="benefits-section">
          <h2>Dlaczego warto wybrać nasze usługi dekarskie w Szczecinie?</h2>
          
          <div className="benefits-grid">
              <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Gwarancja jakości</h3>
                <p>Wszystkie naprawy dachów objęte są wieloletnią gwarancją</p>
              </div>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Darmowa wycena</h3>
                <p>Bezpłatnie przyjedziemy i przygotujemy kosztorys</p>
              </div>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Szybki termin realizacji</h3>
                <p>Naprawimy Twój dach w Szczecinie w ekspresowym tempie</p>
              </div>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Indywidualne podejście</h3>
                <p>Dopasowujemy rozwiązania do Twoich potrzeb i budżetu</p>
              </div>
            </div>
            
            
            <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Doświadczony zespół</h3>
                <p>Nad każdym projektem pracują wykwalifikowani dekarze ze Szczecina</p>
              </div>
            </div>
            <div className="benefit-card">
              <div className="benefit-icony" aria-hidden="true"></div>
              <div className="benefit-content">
                <h3>Reakcja w 24h roboczych</h3>
                <p>Wyjazd na obiekt w ciągu 24 godzin roboczych dla zleceń od 150 m².</p>
              </div>
            </div>
          </div>
        
            
        </div>
      
        
        <div className="cta-box">
          <p>Potrzebujesz profesjonalnej naprawy dachu w Szczecinie?</p>
         <div className="contact-info">
  Zadzwoń do nas: <PhoneLink className="phone-number">+48 518 144 882</PhoneLink>
</div>
<PhoneLink className="cta-button">Bezpłatna wycena</PhoneLink>
        </div>
      </div>
    </section>
  );
}


export default RepairSection;